import { Typography } from '../Typography';

import { LinkStyled } from './LinkLabel.styles';
import { LinkLabelProps } from './types';

/**
 * Link label component.
 */
export const LinkLabel = ({
  label,
  title,
  typographyVariant = 'body',
  ...linkProps
}: LinkLabelProps) => (
  <LinkStyled {...linkProps}>
    <Typography
      className="link-label"
      title={title}
      variant={typographyVariant}
    >
      {label}
    </Typography>
  </LinkStyled>
);
